Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing,
    container = _STYLES$useStyles.container,
    fontSemiBold = _STYLES$useStyles.fontSemiBold,
    colors = _STYLES$useStyles.colors,
    fontSize = _STYLES$useStyles.fontSize,
    lineHeight = _STYLES$useStyles.lineHeight,
    fontRegular = _STYLES$useStyles.fontRegular;
  var styles = _reactNative.StyleSheet.create({
    container: container,
    heading: {
      textAlign: 'center',
      marginBottom: spacing.l
    },
    section: {
      marginBottom: spacing.xxxl
    },
    cta: {
      marginTop: spacing.normal,
      alignSelf: 'center'
    },
    footprintSuffix: Object.assign({}, fontSemiBold, {
      fontSize: fontSize.s,
      lineHeight: lineHeight.s,
      color: colors.brand,
      textAlign: 'center'
    }),
    footprintAccuracy: Object.assign({}, fontRegular, {
      fontSize: fontSize.s,
      lineHeight: lineHeight.s,
      color: colors.brand,
      textAlign: 'center',
      maxWidth: (0, _styles.getREM)(21),
      alignSelf: 'center',
      marginTop: spacing.l
    }),
    footprintValue: Object.assign({
      fontSize: fontSize.xxl,
      color: colors.alternative
    }, _reactNative.Platform.select({
      web: {
        lineHeight: "calc(".concat(fontSize.xxl, " * 1.2)")
      },
      "default": {
        lineHeight: fontSize.xxl * 1.2
      }
    })),
    footprintUnit: {
      fontSize: fontSize.normal,
      color: colors.alternative
    }
  });
  return {
    styles: styles
  };
};